export enum OPERATION_DETAILS_EVENT_TYPE {
  'USER_INPUT' = 'USER_INPUT',
  'SPECIAL_EVENT' = 'SPECIAL_EVENT',
  'VOICE_APP_RESPONSE' = 'VOICE_APP_RESPONSE'
}
interface VoiceInputEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.USER_INPUT;
  input: string;
}

interface SpecialEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.SPECIAL_EVENT;
  text: string;
}

interface VoiceAppResponseEvent {
  date: string;
  type: OPERATION_DETAILS_EVENT_TYPE.VOICE_APP_RESPONSE;
  response: string;
}

export type EventItem = VoiceInputEvent | SpecialEvent | VoiceAppResponseEvent;

export interface PresentEventsType {
  type: 'PRESENT';
  items: EventItem[];
}

export interface ExpiredEventsType {
  type: 'EXPIRED';
  message: string;
}

export type EventsType = PresentEventsType | ExpiredEventsType;
